import Link from 'next/link';

import './Breadcrumbs.scss';
import ChevronRight from '../../../shared/assets/icons/redesign/chevron-right.svg';

export default function Breadcrumbs({ items }) {
  return (
    items ? (
      <div className="breadcrumbs">
        {items.map((item, idx) => (
          <span key={idx} className="breadcrumbs-item">
            <Link href={item.uri} prefetch={false}>{item.title}</Link>

            {items.length !== idx + 1 && (
              <ChevronRight className="breadcrumbs-arrow" />
            )}
          </span>
        ))}
      </div>
    ) : null
  );
}
